import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { ClientLoaderService } from './core/util/client-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private paginatorIntl: MatPaginatorIntl,
    private translate: TranslateService,
    private clientLoader: ClientLoaderService,
  ) {
    this.translate.setDefaultLang('es');
    this.translate.use('es');
  }

  ngOnInit(): void {
    this.hideLoadingScreen();
    this.traduccionPaginator();
  }

  private hideLoadingScreen(): void {
    const loadingEl = document.getElementById('app-loading');
    if (loadingEl) {
      loadingEl.remove();
    }
  }

  private traduccionPaginator(): void {
    this.paginatorIntl.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
    this.paginatorIntl.firstPageLabel = '';
    this.paginatorIntl.previousPageLabel = '';
    this.paginatorIntl.nextPageLabel = '';
    this.paginatorIntl.lastPageLabel = '';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return this.translate.instant('PAGINATOR.RANGE_EMPTY', {length});
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return this.translate.instant('PAGINATOR.RANGE', {start: startIndex + 1, end: endIndex, length});
    };
  }
}
